/* eslint-disable */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { Row, Col, Button, Label, Spacer, Checkbox, Divider, Radio, Tooltip } from '@cleartrip/bento';
import { motion } from 'framer-motion';
import { AutoComplete } from 'components/composite';
import { SrpBanner } from 'components/travelsafe';
import { scrollTo } from 'helper/scrollTo';
import { AirportListContext, FilterContext, StateListContext } from 'context/travelsafe';
import { ReactComponent as Swap } from 'assets/icons/swap.svg';
import { ReactComponent as Information } from 'assets/icons/information.svg';
import { ReactComponent as RouteArrow} from 'assets/icons/routeArrow.svg';
import { isEmpty } from 'helper/isEmpty';
import Clevertap from 'analytics';
import { COM_TAB_MAP_ID, ROUTE_MAP_ID } from 'constants/travelsafe';
import { capitalizeFirst } from 'helper/utils';
import { inFlyinPage, align } from 'helper/flyin';
import CalendarWrapper from 'components/composite/CalendarWrapper';
import { ReactComponent as SherpaLogo } from '../../../assets/logos/poweredbysherpa-onlight.svg';
import SherpaContainer from '../SherpaContainer';
import { langTranslate } from 'helper/arabic';

function GlobalFilterInt({
	variant,
	tab = null,
	loading,
	initialAirports = [],
	initialStates = [],
	initialCountries = [],
	successScrollToRef,
	setShowRoutes = () => {},
	setApiLoading = () => {},
	setOriginCountry = () => {},
	setDestinationCountry = () => {},
	popularRoute = '',
	fromParamsDestination = '',
	setPopularRoute = () => {},
	setShowSideNav = () => { },
	toggle = () => { },
  tripType = '',
  setTripType = () => {},
  layover=true,
  setLayover= () => {},
  onwardLayover={},
  setOnwardLayover= () => {},
  returnLayover={},
  setReturnLayover= () => {},
  isOnwardLayoverValid=true,
  setIsOnwardLayoverValid= () => {},
  isReturnLayoverValid=true,
  setIsReturnLayoverValid= () => {},
  isVaccinated = true,
  setIsVaccinated = () => {},
  setCount = () => {},
  range = '',
  setRange= () => {},
}) {
	const pathName = window.location.pathname;
	const hostName = window.location.hostname;
	let query = new URLSearchParams(window.location.search);
	let history = useHistory();

	const [airports, setAirports] = useContext(AirportListContext);
	const [states, setStates] = useContext(StateListContext);

	const [filter, setFilter] = useContext(FilterContext);
	const [origin, setOrigin] = useState(query.get('from'));
	const [destination, setDestination] = useState(query.get('to'));

	const [fromAirport, setFromAirport] = useState({ name: '', code: '', isCountry: false });
	const [toAirport, setToAirport] = useState({ name: '', code: '', isCountry: false });
	const [isValid, setIsValid] = useState(true);
	const [success, setSuccess] = useState(false);
	const [swap, setSwap] = useState(false);
	const [initial, setInitial] = useState(true);
  const tripTypeRef = useRef(tripType); 
  const onwardLayoverRef = useRef('');
  const returnLayoverRef = useRef('');
  const vaccinatedRef = useRef(isVaccinated);
  // const [count, setCount] = useState(0);
	// const [tripType, setTripType] = useState('O');
	const [dateQuery, setDateQuery] = useState({ return_date: '', depart_date: '' });

	useEffect(() => {
		if (fromAirport.code && toAirport.code) {
			if (origin && destination && !success && filter.isFilterApplied) {
				// if (tab === COM_TAB_MAP_ID.DOM_TRAVEL) scrollTo(successScrollToRef);
				submit();
				// getRedirectionUrl()
			}
			if (
				(fromAirport.isCountry && !toAirport.isCountry) ||
				(!fromAirport.isCountry && toAirport.isCountry) ||
				fromAirport.code === toAirport.code
			) {
				setIsValid(false);
			} else {
				setIsValid(true);
			}
		}
    if((fromAirport.isCountry || toAirport.isCountry) && onwardLayover.code) {
      if(fromAirport.code === onwardLayover.code || toAirport.code === onwardLayover.code ) {
        setIsOnwardLayoverValid(false);
      } else {
        setIsOnwardLayoverValid(true);
      }
    }
    if((fromAirport.isCountry || toAirport.isCountry) && returnLayover.code) {
      if(fromAirport.code === returnLayover.code || toAirport.code === returnLayover.code ) {
        setIsReturnLayoverValid(false);
      } else {
        setIsReturnLayoverValid(true);
      }
    }
	}, [toAirport.code, fromAirport.code, filter]);

	useEffect(() => {
		if (initial) {
			if (!query.has('from') || !query.has('to')) {
				query.set('from', '');
				query.set('to', '');
				if (tab === 'DOM') {
					query.delete('origin');
					query.delete('destination');
				} else {
					query.set('origin', popularRoute.split('_')[0]);
					query.set('destination', popularRoute.split('_')[1]);
					setOriginCountry(popularRoute.split('_')[0]);
					setDestinationCountry(popularRoute.split('_')[1]);
				}

				history.push({ search: query.toString() });
			}
			if (tab === 'DOM') setApiLoading(false);
			setInitial(false);
		} else {
			setShowRoutes(true);
			let obj = { name: '', code: '', isCountry: false };
			setSuccess(false);
			setFromAirport(obj);
			setToAirport(obj);
			setFilter({ ...filter, from: obj, to: obj, isFilterApplied: false });
			setAirports({ ...airports, airportsList: [...initialAirports] });
			setStates({ ...states, statesList: [...initialStates] });
			query.set('from', '');
			query.set('to', '');
			if (tab === 'DOM') {
				query.delete('origin');
				query.delete('destination');
			} else {
        query.set('origin', popularRoute.split('_')[0]);
				query.set('destination', popularRoute.split('_')[1]);
				setOriginCountry(popularRoute.split('_')[0]);
				setDestinationCountry(popularRoute.split('_')[1]);
      }
			history.push({ search: query.toString() });
		}
	}, [tab]);

	useEffect(() => {
		if (!loading) {
			if (origin && destination && airports.airportsList && airports.airportsList.length) {
				let selectedFromAirport = getAirportDetails(origin);
				let selectedToAirport = getAirportDetails(destination);

				if (!isEmpty(selectedFromAirport) && !isEmpty(selectedToAirport)) {
					setFilter({
						...filter,
						from: { code: selectedFromAirport.airportCode, name: selectedFromAirport.name },
						to: { code: selectedToAirport.airportCode, name: selectedToAirport.name },
						isFilterApplied: true,
					});

					setFromAirport({ ...filter.from, code: selectedFromAirport.airportCode, name: selectedFromAirport.name });
					setToAirport({ ...filter.to, code: selectedToAirport.airportCode, name: selectedToAirport.name });
				}
			}
		}
	}, [loading]);

	function getAirportDetails(key) {
		let airport = airports.airportsList.find((airport) => airport.airportCode === key);
		return airport;
	}

	function setFrom(selected) {
		setFromAirport({
			code: selected.airportCode || selected.iso3Code,
			name: capitalizeFirst(selected.name),
			isCountry: selected.iso3Code ? true : false,
		});
		// setFilter({ ...filter, from: { code: selected.airportCode, name: selected.name } });
	}
	function setTo(selected) {
		setToAirport({
			code: selected.airportCode || selected.iso3Code,
			name: capitalizeFirst(selected.name),
			isCountry: selected.iso3Code ? true : false,
		});
		// setFilter({ ...filter, to: { code: selected.airportCode, name: selected.name } });
	}

  function onwardLayoverHandler(selected) {
    if((fromAirport.isCountry || toAirport.isCountry) && (selected.airportCode || selected.iso3Code)) {
      if(fromAirport.code === selected.iso3Code || toAirport.code === selected.iso3Code ) {
        setIsOnwardLayoverValid(false);
      } else {
        setIsOnwardLayoverValid(true);
      }
    }
    setOnwardLayover({
      code: selected.airportCode || selected.iso3Code,
			name: capitalizeFirst(selected.name),
			isCountry: selected.iso3Code ? true : false,
    });
  }

  function returnLayoverHandler(selected) {
    if((fromAirport.isCountry || toAirport.isCountry) && (selected.airportCode || selected.iso3Code)) {
      if(fromAirport.code === selected.iso3Code || toAirport.code === selected.iso3Code ) {
        setIsReturnLayoverValid(false);
      } else {
        setIsReturnLayoverValid(true);
      }
    }
    setReturnLayover({
      code: selected.airportCode || selected.iso3Code,
			name: capitalizeFirst(selected.name),
			isCountry: selected.iso3Code ? true : false,
    });
  }

	function checkDomain() {
		if (
			pathName.toLowerCase() === '/travelsafe/ae' ||
			(pathName.toLowerCase() === '/travelsafe' && (hostName === 'www.cleartrip.ae' || hostName === 'cleartrip.ae'))
		) {
			setShowSideNav(true);
		} else {
			setShowRoutes(false);
		}
	}

	function checkOnClear() {
		if (
			pathName.toLowerCase() === '/travelsafe/ae' ||
			(pathName.toLowerCase() === '/travelsafe' && (hostName === 'www.cleartrip.ae' || hostName === 'cleartrip.ae'))
		) {
			setShowSideNav(false);
		}
	}

	function submit() {
		let filteredAirports = filterAirports();
		let filteredStates = filterStates();
		setOrigin('');
		setDestination('');
		setStates({ ...states, statesList: [...filteredStates] });
		setAirports({ ...airports, airportsList: [...filteredAirports] });
		setSuccess(true);
		setFilter({ ...filter, isFilterApplied: true, from: { ...fromAirport }, to: { ...toAirport } });
		checkDomain();
		setOriginCountry(fromAirport.code);
		setDestinationCountry(toAirport.code);
		setShowRoutes(false);
		if (tab === 'DOM') {
			query.set('from', fromAirport.code);
			query.set('to', toAirport.code);
		} else {
			query.set('origin', fromAirport.code);
			query.set('destination', toAirport.code);
			query.set('from', '');
			query.set('to', '');
		} 
    if(fromParamsDestination) {
      fromParamsDestination.current = '';
    }
    setCount(prevState => prevState + 1);
    // if(tripType !== tripTypeRef.current) {
    //   tripTypeRef.current = tripType;
    //   if(onwardLayoverRef.current !== onwardLayover.code || returnLayoverRef.current !== returnLayover.code) {
    //     onwardLayoverRef.current = onwardLayover.code;
    //     returnLayoverRef.current = returnLayover.code;
    //     getRestrictionsFromSherpa();
    //   } else if(count !== 0) {
    //     getRestrictionsFromSherpa();
    //   } else {
    //     setCount(prevCount => prevCount + 1);
    //   }
    // } else if(onwardLayoverRef.current !== onwardLayover.code || returnLayoverRef.current !== returnLayover.code) {
    //   onwardLayoverRef.current = onwardLayover.code;
    //   returnLayoverRef.current = returnLayover.code;
    //   getRestrictionsFromSherpa();
    // } else if(vaccinatedRef.current !== isVaccinated) {
    //   getRestrictionsFromSherpa()
    // }
		history.push({ search: '?' + query.toString() });

		// setFilter({ ...filter, isFilterApplied: true });
		Clevertap.event('Air_UI_action', {
			action_name: 'route_search_travelsafe',
			action_value: filter.from.code + '_' + filter.to.code,
		});
		if (tab === COM_TAB_MAP_ID.DOM_TRAVEL) scrollTo(successScrollToRef);
		// setTimeout(()=> {
		// 	setFilter({ ...filter, isFilterApplied: false });
		// },1000)
	}

	function filterAirports() {
		let filteredAirports = initialAirports
			.filter((airport) => airport.airportCode === fromAirport.code || airport.airportCode === toAirport.code)
			.sort((a, b) => {
				if (a.airportCode === filter.to.code) return -1;
				else return 1;
			});

		return filteredAirports;
	}

	function filterStates() {
		let destState,
			filteredStates = [];

		initialStates.map((state) => {
			if (state.airportsList) {
				state.airportsList.map((item) => {
					if (item.airportCode === toAirport.code) {
						destState = state.name;
					}
					if (item.airportCode === toAirport.code || item.airportCode === fromAirport.code) filteredStates.push(state);
				});
			}
		});

		filteredStates.sort(function (a, b) {
			if (a.name.toLowerCase() == destState.toLowerCase()) {
				return -1;
			} else {
				return 1;
			}
		});

		let reducedStates = filteredStates.reduce((acc, current) => {
			const x = acc.find((item) => item.name.toLowerCase() === current.name.toLowerCase());
			if (!x) {
				return acc.concat([current]);
			} else {
				return acc;
			}
		}, []);
		return reducedStates;
	}

	function onSwap() {
		setSwap(!swap);
		let temp = fromAirport;
		setFromAirport(toAirport);
		setToAirport(temp);
		// setFilter({ ...filter, from: filter.to, to: temp });
	}

	function getSwapStyle(){
		if(inFlyinPage() && align()==="rtl")
		return {transform: "scaleX(-1)"}
	}
  
	function onClear() {
		let obj = { name: '', code: '', isCountry: false };
		setSuccess(false);
		setFromAirport(obj);
		setToAirport(obj);
		setFilter({ ...filter, from: obj, to: obj, isFilterApplied: false });
		setAirports({ ...airports, airportsList: [...initialAirports] });
		setStates({ ...states, statesList: [...initialStates] });
		setShowRoutes(true);
		checkOnClear();
		setOriginCountry(popularRoute.split('_')[0]);
		setDestinationCountry(popularRoute.split('_')[1]);
		query.set('from', '');
		query.set('to', '');
		if (tab !== 'DOM') {
			query.set('origin', popularRoute.split('_')[0]);
			query.set('destination', popularRoute.split('_')[1]);
		}
		history.push({ search: '?' + query.toString() });
	}

	function dateClick(date) {
		if (date.to) {
			setTripType('ROUND_TRIP');
		}
	}

	function getCtRedirectionUrl() {
		const BASE_URL =
			'https://www.cleartrip.com/flights/results?origin=&destination=&adults=1&childs=0&class=Economy&depart_date=&from=&infants=0&to=';
		const DAYS_TO_ADD = 14;
		const DEPART_DATE = dayjs().add(DAYS_TO_ADD, 'day').format('DD/MM/YYYY');

		let url = new URL(BASE_URL);
		let params = new URLSearchParams(url.search.slice(1));
		params.set('origin', filter.from.name);
		params.set('destination', filter.to.name);
		params.set('from', filter.from.code);
		params.set('to', filter.to.code);
		params.set('depart_date', DEPART_DATE);
		url.search = params;
		return url.href;
	}

	function getAmazonRedirectionUrl() {
		const BASE_URL = 'https://www.amazon.in/flights/';
		return BASE_URL;
	}

	// function getNote()
	// {
	// 	if(align() === "rtl")  
	// 	return <><span className='fw-500'>ملاحظة</span> <span>: للرحلات الدولية، من فضلك أدخل دولة الذهاب و دولة الوصول</span></>
	// 	else
	// 	return <><span className='fw-500'>NOTE</span> <span>: For international routes, please enter origin and destination country</span></>
	// }

	function getOriginPlaceholder()
	{
		return (tab && tab === COM_TAB_MAP_ID.INT_TRAVEL) || !tab 
		? langTranslate('Enter origin country') 
		: 'Enter origin airport/city'

	}

	function getDestinationPlaceholder()
	{
		return (tab && tab === COM_TAB_MAP_ID.INT_TRAVEL) || !tab
		? langTranslate('Enter destination country')
		: 'Enter destination airport/city'
	}
  const layoverFieldHandler = (value) => {
    setLayover(value);
    setOnwardLayover({ name: '', code: '', isCountry: false });
    setReturnLayover({ name: '', code: '', isCountry: false });
    setIsOnwardLayoverValid(true);
    setIsReturnLayoverValid(true);
  }
  if(tab ===COM_TAB_MAP_ID.INT_TRAVEL){
	  return (
		<>
		<div>
		   <SherpaContainer>Loading sherpa</SherpaContainer>
		</div>
		</>
	  )
  }
	return (
		<>
			<form>
				<>
					<div className='flex flex-between flex-top'>
						{/* <Label className='fs-4 c-neutral-700 fw-500'> */}
						<div className='flex-1'>
							{(variant === 'AMAZON' || variant === 'GONUCLEI') &&
								(filter.isFilterApplied ? (
									<Label className='fs-4 c-neutral-700 fw-500'> Showing information for the following route:</Label>
								) : (
									<Label className='fs-4 c-neutral-700 fw-500'> Get information specific to your route</Label>
								))}
							{/* {(variant !== 'AMAZON' || variant === 'GONUCLEI') &&
								tab !== COM_TAB_MAP_ID.DOM_TRAVEL &&
								tab !== COM_TAB_MAP_ID.INT_TRAVEL && (
									<Label className='fs-2 fw-400'>
										<span className='fw-500'>NOTE</span>: For international routes, please enter origin and destination country
									</Label>
								)} */}
							{/* </Label> */}
						</div>
						{/* {filter.isFilterApplied && (
							<p onClick={onClear} className='ws-nowrap fs-4 c-secondary-500 fw-500 c-pointer'>
								{align()==="rtl" ? 'مسح الكل' : 'Clear all'} 
							</p>
						)} */}
					</div>
					{(variant === 'AMAZON' || variant === 'GONUCLEI' || tab === COM_TAB_MAP_ID.DOM_TRAVEL) && <Spacer className='pt-3' />}
				</>

				<Row className='flex-middle p-relative'>
					<Col span={tab === "DOM" ? 8 : 7} xs={24}>
						<AutoComplete
							className='fs-4 m-0 py-2 pl-4'
							loading={loading}
							inputVal={fromAirport.code && fromAirport.name + ' (' + fromAirport.code + ')'}
							onSelect={setFrom}
							initialList={initialAirports}
							countriesList={initialCountries}
							list={airports.airportsList}
							size='lg'
							placeholder={ getOriginPlaceholder() }
							align={align}
						/>
					</Col>
					<div className='ta-center d-none--xs'>
						<motion.div
							className='flex flex-middle flex-center'
							initial={{ rotate: 0 }}
							animate={{ rotate: swap ? 180 : 0 }}
							transition={{
								type: 'spring',
								stiffness: 260,
								damping: 20,
							}}
						>
							<Swap
								height={16}
								width={16}
								onClick={fromAirport.code && toAirport.code ? onSwap : null}
								className={classNames('c-secondary-500 c-pointer', {
									'c-not-allowed c-neutral-400': !fromAirport.code && !toAirport.code,
								})}
								style={getSwapStyle()}
							/>
						</motion.div>
					</div>
					<div className={`ta-center d-none d-block--xs p-absolute z-10 t-6 ${align() === "ltr" ? "r-4" : "l-4"} p-2 bc-neutral-200 bg-white ba bw-1 br-100`}>
						<motion.div
							className='flex flex-middle flex-center'
							initial={{ rotate: 90 }}
							animate={{ rotate: swap ? 270 : 90 }}
							transition={{
								type: 'spring',
								stiffness: 260,
								damping: 20,
							}}
						>
							<Swap
								height={16}
								width={16}
								onClick={fromAirport.code && toAirport.code ? onSwap : null}
								className={classNames('c-secondary-500 c-pointer', {
									'c-not-allowed c-neutral-400': !fromAirport.code || !toAirport.code,
								})}
								style={getSwapStyle()}
							/>
						</motion.div>
					</div>
					<Spacer className='pt-2--xs' />
					<Col span={tab === "DOM" ? 8 : 7} xs={24}>
						<AutoComplete
							className='fs-4 m-0 py-2 pl-4'
							loading={loading}
							inputVal={toAirport.code && toAirport.name + ' (' + toAirport.code + ')'}
							onSelect={setTo}
							initialList={initialAirports}
							countriesList={initialCountries}
							list={airports.airportsList}
							size='lg'
							placeholder={ getDestinationPlaceholder() }
							hasError={!isValid}
							align={align}
						/>
						{!tab && !isValid && <p className='p-absolute mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')} </p>}
						{tab && tab === COM_TAB_MAP_ID.INT_TRAVEL && !isValid && (
							<p className='p-absolute mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')}</p>
						)}
						{tab && tab === COM_TAB_MAP_ID.DOM_TRAVEL && !isValid && (
							<p className='p-absolute mt-1 fs-3 c-error-500'>Please select a different arrival airport</p>
						)}
					</Col>
					{tab === COM_TAB_MAP_ID.DOM_TRAVEL ? <Col xs={24}>
						<Button
							type='submit'
							className='mt-6--xs'
							type='secondary'
							onClick={() => {
								// setFilter({...filter, isFilterApplied: true})
								submit();
								toggle();
							}}
							busy={!toAirport.code || !fromAirport.code || !isValid ? false : loading}
							full
							disabled={!toAirport.code || !fromAirport.code || !isValid}
						>
							{langTranslate("Get information")} 
						</Button>
					</Col> : 
          <Col xs={24} className="mt-4--xs">
            <CalendarWrapper
								roundTrip={tripType === 'ROUND_TRIP' ? true : false}
								onwardJourny='India'
								returnJourny='UAE'
								// departDate={
								// 		query.depart_date === 'Invalid Date' || isEmpty(query.depart_date)
								// 				? getFormattedDate(new Date(), 'DD/MM/YYYY')
								// 				: query.depart_date
								// }
								// returnDate={
								// 		query.return_date === 'Invalid Date'
								// 				? getFormattedDate(new Date(), 'DD/MM/YYYY')
								// 				: query.return_date
								// }

								dateClick={dateClick}
								searchParams={dateQuery}
                range={range}
                setRange={setRange}
							/>
          </Col>
          }
				</Row>
        {/* Desktop View */}
        {tab !== COM_TAB_MAP_ID.DOM_TRAVEL && 
        <><div className="flex flex-middle flex-between mt-7 d-block d-none--xs">
          {layover ? 
            <span className="fs-4 fw-500 c-secondary-500 lh-title c-pointer" onClick={() => layoverFieldHandler(false)}>{langTranslate('Add Layover country')}</span> :
            <div>
              <span className={`fs-4 c-neutral-700 lh-title ${align() === 'ltr' ? "mr-2" : "ml-2"}`}>{langTranslate('Layover Country')}</span>
              <span className="fs-4 fw-500 c-secondary-500 lh-title c-pointer" onClick={() => layoverFieldHandler(true)}>{langTranslate('Remove')}</span>
            </div>
          }
          {layover && <div className="flex flex-middle">
            <div className="flex">
              <Checkbox size="md" checked={isVaccinated} onClick={() => setIsVaccinated(!isVaccinated)}>
                <span className={`fs-4 lh-title fw-500 c-neutral-900 ${align() === 'ltr' ? "ml-2" : "mr-2"}`}>{langTranslate('Fully Vaccinated')}</span>
              </Checkbox>
              <Spacer className="mr-2"/>
              <Tooltip content={<div className="fs-3"><p className="mb-2">{langTranslate('Most COVID vaccines require two doses and a waiting period of upto 21 days after the final dose. If you don’t meet these requirements, you are NOT fully vaccinated.')}</p>
              <p>{langTranslate('Vaccines allowed may vary based on country. Check government sources for more info.')}</p></div>}><Information className="flex flex-middle"/></Tooltip>
            </div>
            <div className={align() === 'ltr' ? "ml-7" : "mr-7"}>
              <Button
                type='submit'
                className='mt-6--xs py-2 px-15'
                type='secondary'
                onClick={() => {
                  // setFilter({...filter, isFilterApplied: true})
                  submit();
                  toggle();
                }}
                busy={!toAirport.code || !fromAirport.code || !isValid ? false : loading}
                full
                disabled={!toAirport.code || !fromAirport.code || !isValid || (tripType === 'ROUND_TRIP' && !range.to ? true : false) }
              >
                {langTranslate("Get information")}
              </Button>
            </div>
          </div>}
        </div>
        {/* Desktop Layover Fields */}
        {!layover && <div className="mt-3 d-block d-none--xs">
          <Row>
            <Col span={7} xs={24}>
              <AutoComplete
                className='fs-4 m-0 py-2 pl-4'
                loading={loading}
                inputVal={onwardLayover.code && onwardLayover.name + ' (' + onwardLayover.code + ')'}
                onSelect={onwardLayoverHandler}
                initialList={initialAirports}
                countriesList={initialCountries}
                list={airports.airportsList}
                size='lg'
                placeholder={langTranslate("Enter onward layover country")}
                hasError={!isOnwardLayoverValid}
              />
              {!isOnwardLayoverValid && <p className='mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')}</p>}
            </Col>
            <Spacer className="mr-4"/>
            {tripType === 'ROUND_TRIP' && (
              <Col span={7} xs={24}>
                <AutoComplete
                  className='fs-4 m-0 py-2 pl-4'
                  loading={loading}
                  inputVal={returnLayover.code && returnLayover.name + ' (' + returnLayover.code + ')'}
                  onSelect={returnLayoverHandler}
                  initialList={initialAirports}
                  countriesList={initialCountries}
                  list={airports.airportsList}
                  size='lg'
                  placeholder={langTranslate("Enter return layover country")}
                  hasError={!isReturnLayoverValid}
                />
                {!isReturnLayoverValid && <p className='mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')}</p>}
              </Col>
            )}
          </Row>
          <Divider className="bc-neutral-100 my-4"/>
          <div className="flex flex-middle flex-end">
            <div className="flex">
              <Checkbox size="md" checked={isVaccinated} onClick={() => setIsVaccinated(!isVaccinated)}>
                <span className={`fs-4 lh-title fw-500 c-neutral-900 ${align() === 'ltr' ? "ml-2" : "mr-2"}`}>{langTranslate('Fully Vaccinated')}</span>
              </Checkbox>
              <Spacer className="mr-2"/>
              <Tooltip className="flex" content={<div className="fs-3"><p className="mb-2">{langTranslate('Most COVID vaccines require two doses and a waiting period of upto 21 days after the final dose. If you don’t meet these requirements, you are NOT fully vaccinated.')}</p>
              <p>{langTranslate('Vaccines allowed may vary based on country. Check government sources for more info.')}</p></div>}><Information className="flex flex-middle"/></Tooltip>
            </div>
            <div className={align() === 'ltr' ? "ml-7" : "mr-7"}>
              <Button
                type='submit'
                className='mt-6--xs py-2 px-15'
                type='secondary'
                onClick={() => {
                  // setFilter({...filter, isFilterApplied: true})
                  submit();
                  toggle();
                }}
                busy={!toAirport.code || !fromAirport.code || !isValid ? false : loading}
                full
                disabled={!toAirport.code || !fromAirport.code || !isValid || (!isOnwardLayoverValid ? true : false) || (tripType === 'ROUND_TRIP' ? (!isReturnLayoverValid ? true : false) || (tripType === 'ROUND_TRIP' && !range.to ? true : false) : false)}
              >
                {langTranslate("Get information")}
              </Button>
            </div>
          </div>
        </div>}
        </>}
        {/* Mobile View */}
        {tab !== COM_TAB_MAP_ID.DOM_TRAVEL && 
          <div className="d-none d-block--xs mt-5">
            {
              layover ? <span className="fs-4 fw-500 c-secondary-500 lh-title c-pointer" onClick={() => layoverFieldHandler(false)}>{langTranslate('Add Layover country')}</span> : 
              <div className="flex flex-between">
                <span className="fs-3--xs c-neutral-700">{langTranslate('Layover Country')}</span>
                <span className="fs-3--xs c-pointer c-secondary-500 fw-500" onClick={() => layoverFieldHandler(true)}>{langTranslate('Remove')}</span>
              </div>
            }
            {
              !layover && (
                <>
                  <AutoComplete
                    className='fs-4 m-0 py-2 mt-3'
                    loading={loading}
                    inputVal={onwardLayover.code && onwardLayover.name + ' (' + onwardLayover.code + ')'}
                    onSelect={onwardLayoverHandler}
                    initialList={initialAirports}
                    countriesList={initialCountries}
                    list={airports.airportsList}
                    size='lg'
                    placeholder={langTranslate("Enter onward layover country")}
                    hasError={!isOnwardLayoverValid}
                  />
                  {!isOnwardLayoverValid && <p className='mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')}</p>}
                  <Spacer className="mt-2"/>
                  {
                    tripType === "ROUND_TRIP" && (
                      <>
                        <AutoComplete
                          className='fs-4 m-0 py-2'
                          loading={loading}
                          inputVal={returnLayover.code && returnLayover.name + ' (' + returnLayover.code + ')'}
                          onSelect={returnLayoverHandler}
                          initialList={initialAirports}
                          countriesList={initialCountries}
                          list={airports.airportsList}
                          size='lg'
                          placeholder={langTranslate("Enter return layover country")}
                          hasError={!isReturnLayoverValid}
                        />
                        {!isReturnLayoverValid && <p className='mt-1 fs-3 c-error-500'>{langTranslate('Please select a different Country')}</p>}
                      </>
                    )
                  }
                </>
              )
            }
            <Divider className="mt-4 mb-5 bc-neutral-100"/>
            <div className="flex flex-start">
              <div>
                <Checkbox size="md" checked={isVaccinated} onClick={() => setIsVaccinated(!isVaccinated)}>
                  <span className={`fs-4 lh-title fw-500 c-neutral-900 ${align() === 'ltr' ? "ml-2" : "mr-2"}`}>{langTranslate('Fully Vaccinated')}</span>
                </Checkbox>
              </div>
              <Spacer className="mr-2"/>
              <Tooltip content={<div className="fs-3"><p className="mb-2">{langTranslate('Most COVID vaccines require two doses and a waiting period of upto 21 days after the final dose. If you don’t meet these requirements, you are NOT fully vaccinated.')}</p>
              <p>{langTranslate('Vaccines allowed may vary based on country. Check government sources for more info.')}</p></div>}><Information /></Tooltip>
            </div>
            <Button
              type='submit'
              className='mt-6 py-2 px-15'
              type='secondary'
              onClick={() => {
                // setFilter({...filter, isFilterApplied: true})
                submit();
                toggle();
              }}
              busy={!toAirport.code || !fromAirport.code || !isValid ? false : loading}
              full
              disabled={!toAirport.code || !fromAirport.code || !isValid || (!layover ? (!isOnwardLayoverValid ? true : false) : false) || (!layover ? (tripType === 'ROUND_TRIP' ? (!isReturnLayoverValid ? true : false): false) || (tripType === 'ROUND_TRIP' && !range.to ? true : false) : false)}
            >
              {langTranslate("Get information")}
            </Button>
          </div>
        }
				{tab !== COM_TAB_MAP_ID.DOM_TRAVEL ? <div className={align() === "rtl" ? "ta-left o-80 mt-2" : "ta-right o-80 mt-2"}><SherpaLogo width={120}/></div> : null}
			</form>

			{/* <SrpBanner
				isVisible={success}
				filter={filter}
				redirectionUrl={variant === 'AMAZON' ? getAmazonRedirectionUrl() : getCtRedirectionUrl()}
			/> */}
		</>
	);
}

export default GlobalFilterInt;
